const getQueryUrl = (endpoint, queries) => {
  let url = `${endpoint}?`;

  for (const key in queries) {
    url += `&${key}=${queries[key]}`
  };

  return url;
}

export default getQueryUrl;